"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var constant_1 = require("../../constant");
var style_1 = require("../../style");
var styles_1 = require("./styles");
var Divider = function (_a) {
    var color = _a.color, _b = _a.type, type = _b === void 0 ? styles_1.SOLID : _b, size = _a.size, _c = _a.height, height = _c === void 0 ? 1 : _c, _d = _a.direction, direction = _d === void 0 ? 'horizontal' : _d, children = _a.children;
    var theme = react_1.useTheme();
    var dividerSize = size || height;
    var dividerColor = color || theme.name === constant_1.DESIGN_SYSTEM
        ? style_1.DesignSystemThemeColor.Gray.LIGHT_3
        : style_1.SixsenseColor.Gray.DEFAULT;
    var dividerStyle = react_2.useMemo(function () { return styles_1.getDividerStyle(dividerSize, type, dividerColor, direction); }, [dividerSize, type, dividerColor, direction]);
    return children ? (react_1.jsx("div", { css: styles_1.containerStyle(direction) },
        react_1.jsx("div", { css: dividerStyle }),
        react_1.jsx("div", { css: styles_1.childContainerStyle }, children),
        react_1.jsx("div", { css: dividerStyle }))) : (react_1.jsx("div", { css: dividerStyle }));
};
exports.default = Divider;
